import { makeStyles, tokens, shorthands } from '@fluentui/react-components';

export const useBudgetInputStyles = makeStyles({
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  label: {
    marginBottom: tokens.spacingVerticalXS,
  },
  input: {
    maxWidth: '280px',
    ...shorthands.flex(1),
  },
  dropdown: {
    minWidth: '150px',
    marginLeft: tokens.spacingHorizontalXS,
  },
  currency: {
    ...shorthands.margin('0', '0', '0', tokens.spacingHorizontalS),
  },
});
